<div class="mb-3" [formGroup]="group()">
  <h2>Medical Aid Details</h2>
  @if (!hasScheme()) {
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <xui-mat-autocomplete
          placeholder="Search Schemes"
          (itemSelected)="setMedicalScheme($event)"
          [searchObservable]="searchSchemes"
          [displayResultsCardTemplate]="schemeTemplate"
          [isInvalid]="!!group().controls.schemeId.errors?.['apiError']">
        </xui-mat-autocomplete>
        <ng-template #schemeTemplate let-result="result" let-queryText="queryText">
          <div class="p-2">
            <h2 class="mb-1" [innerHtml]="'Name: ' + result.name | textHighlight: queryText"></h2>
            <p class="mb-1">Administrator: {{ result.administrator }}</p>
          </div>
        </ng-template>
        @if (group().controls.schemeId.errors?.['apiError']) {
          <xui-alert type="danger" [message]="group().controls.schemeId.errors?.['apiError']" [dismissible]="false"></xui-alert>
        }
      </div>
    </div>
  }
  @if (hasScheme()) {
    <div class="row">
      <div class="col-sm-12 col-md-6">
        @if (group().controls.schemeId.value === 0) {
          <div class="alert alert-warning mb-3 d-flex flex-row align-items-center mat-text-warn justify-content-center">
            <mat-icon class="me-2">warning</mat-icon>
            Warning: Invalid or unused scheme. Please remove and re-add the medical aid scheme.
          </div>
        }
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Medical Aid</mat-label>
          <input matInput formControlName="scheme" type="text" readonly/>
          <button matSuffix mat-icon-button (click)="clearMedicalScheme()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="fill" color="primary" class="w-100">
        <mat-label>Medical Aid Plan</mat-label>
        <input matInput formControlName="plan" type="text"/>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="fill" color="primary" class="w-100">
        <mat-label>Medical Aid Number</mat-label>
        <input matInput formControlName="medicalAidNumber" type="text"/>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="fill" color="primary" class="w-100">
        <mat-label>Dependant Code</mat-label>
        <input matInput formControlName="dependantCode" type="text"/>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="fill" color="primary" class="w-100">
        <mat-label>Main Member&apos;s First Name</mat-label>
        <input matInput formControlName="mainMembersFirstName" type="text"/>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="fill" color="primary" class="w-100">
        <mat-label>Main Member&apos;s Surname</mat-label>
        <input matInput formControlName="mainMembersSurname" type="text"/>
      </mat-form-field>
    </div>
  </div>
</div>
